// extracted by mini-css-extract-plugin
export var closeButton = "_1v-3";
export var header = "_1v-0";
export var link = "_1v-1";
export var retryButton = "_1v-2";